// extracted by mini-css-extract-plugin
export var root = "O0m6";
export var rootButton = "LO6Y";
export var rootContainer = "dYQx";
export var rootDescription = "O9v1";
export var rootHeading = "YCVr";
export var rootIcon = "-0sr";
export var rootImage = "Xqt9";
export var rootMain = "q2Wk";
export var rootPicture = "xZxU";